import React from 'react';
import PropTypes from 'prop-types';

const ColumnLeft = (props) => {
    const {
        rowYear,
    } = props;

    return (
        <div className="hp-recentStakesPerformers__container__content__row__left">
            {
                rowYear
            }
        </div>
    );
};

ColumnLeft.propTypes = {
    rowYear: PropTypes.string,
};

export default ColumnLeft;



// WEBPACK FOOTER //
// ./src/js/horse/recentStakesPerformers/components/ColumnLeft.jsx